/**
 * Промисы в пути по ключу (обычно id проекта): кто-то другой может узнать, что работа ещё идёт, и дождаться её.
 * Ключ свободен, когда завершились все его промисы, в том числе с ошибкой.
 */
export function createInFlightTracker() {
  const inFlight = new Map<string, Set<Promise<unknown>>>();
  return {
    track<T>(key: string, work: Promise<T>): Promise<T> {
      const set = inFlight.get(key) ?? new Set<Promise<unknown>>();
      inFlight.set(key, set);
      set.add(work);
      return work.finally(() => {
        set.delete(work);
        if (set.size === 0 && inFlight.get(key) === set) inFlight.delete(key);
      });
    },
    has(key: string): boolean {
      return inFlight.has(key);
    },
    /** Ждёт всё, что в пути сейчас; ошибки не пробрасывает — их показывает тот, кто работу начал. */
    async wait(key: string): Promise<void> {
      const set = inFlight.get(key);
      if (set) await Promise.allSettled([...set]);
    },
  };
}
